import httpClient from './httpClient';

const API_BASE = '/api/leftovers';

const leftoverService = {
  async findAvailable(params) {
    // Clean up undefined values from params
    const cleanParams = {};
    Object.keys(params || {}).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        cleanParams[key] = params[key];
      }
    });
    const response = await httpClient.get(`${API_BASE}/available`, { params: cleanParams });
    return response.data;
  },

  async getById(id) {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  },

  async getByParentId(parentId) {
    const response = await httpClient.get(`${API_BASE}/by-parent/${parentId}`);
    return response.data;
  }
};

export default leftoverService;
